'use client'
import { motion } from 'framer-motion'

const LoadingWheel = ({color}) => {
    const options = {
        borderTop: `.4rem solid ${color}`,
        borderLeft: `.4rem solid ${color}`,
        borderRight: `.4rem solid ${color}`,
        borderBottom: '.4rem solid transparent',
        height: '100%',
        aspectRatio: '1/1',
        margin: 'auto',
    }

    const spin = {
        rotate: [0, 360],
        transition: {
            duration: 1,
            ease: 'linear',
            repeat: Infinity,
            repeatType: 'loop'
        }
    }

    return (
        <>
            <motion.div className='rounded-full' style={ options } animate={ spin } />
        </>
    )
}

export default LoadingWheel;